<!----------------------- Компонент налаштувань користувача --------------------->
<template>
  <bigmodal @close="closeWindow()" :title="lang['Settings']">
    <div v-if="form != null">
      <div class="person-settings">
        <!--
        ↓↓↓ Левый блок с настройками юзера ↓↓↓
        -->
        <div class="person-settings_info">
          <!-- Имя пользователя -->
          <div v-if="!showEditName" class="person-settings_name" @click="showEditName = true">
            <h5 class="h5-user-name">{{ form.user_name }}</h5>
            <button class="btn btn-name">
              <span class="icon-pencil blue-color"></span>
            </button>
          </div>
          <div v-else class="col-md-10 info-field">
            <div class="name-div">
              <b-form-input class="name-input" type="text" v-model="newName" :state="stateName" />
              <button class="btn rollBack" @click="goBack">
                <svg data-v-77c06740="" xmlns="http://www.w3.org/2000/svg" height="28px" viewBox="0 -960 960 1060"
                  width="24px" fill="#fff">
                  <path data-v-77c06740=""
                    d="M280-200v-80h284q63 0 109.5-40T720-420q0-60-46.5-100T564-560H312l104 104-56 56-200-200 200-200 56 56-104 104h252q97 0 166.5 63T800-420q0 94-69.5 157T564-200H280Z">
                  </path>
                </svg>
              </button>
              <button class="btn name-button" @click="editName">
                <span class="icon-disk"></span>
              </button>
            </div>
          </div>
          <!--
            Настройки пользователя
          -->
          <div class="info-fields">
            <!-- Почта юзера -->
            <div class="col-md-10 info-field" v-if="email != ''">
              <label for="email">{{ lang['Email'] }}</label>
              <div class="email-and-phone-and-description-div">
                <b-form-input readonly type="text" v-model="email" />
                <button class="btn btn-secondary input-edit-button" @click="showEditModal = !showEditModal">
                  <span class="icon-pencil"></span>
                </button>
              </div>
            </div>
            <div v-else class="col-md-10 info-field email-else">
              <label for="email">{{ lang['Email'] }}</label>
              <button class="btn add-email" @click="showAddEmail = true">{{ lang['AddEmail']
              }}</button>
            </div>
            <!-- Номер телефона -->
            <div class="col-md-10 info-field">
              <label for="phone">{{ lang['Phone'] }}</label>
              <div class="email-and-phone-and-description-div">
                <b-form-input type="text" v-model="personPhone" readonly />
                <button class="btn btn-secondary input-edit-button" @click="showEditPhone = !showEditPhone">
                  <span class="icon-pencil"></span>
                </button>
              </div>
            </div>
            <!-- Список языков -->
            <div class="col-md-10 info-field">
              <label for="lang">{{ lang['Language'] }}</label>
              <SelectLangs v-if="personLang" @changeLang="changeLang($event)" :personLang="this.personLang" />
            </div>
          </div>
          <!-- Добавление\изменение пароля/просмотр сессий -->
          <div class="links_block">
            <div class="change-pass">
              <span v-if="!form.have_password" class="add-company" @click="showAddPassword = !showAddPassword">{{
                lang['AddPassword'] }}</span>
              <span v-else class="add-company" @click="showRePass = !showRePass">{{ lang['ChangePassword'] }}</span>
            </div>
          </div>
        </div>


        <!--
        ↓↓↓ Правый блок с сервисами ↓↓↓
        -->
        <div class="person-settings_services">
          <h5 class="h5-service-name">{{ lang['services'] }}</h5>
          <div class="info-fields">
            <!-- Facebook -->
            <!-- <div class="col-md-10 info-field max-width">
              <label>&nbsp;</label>
              <b-button @click="facebookAction" :variant="
                form.services.facebook ? 'primary' : 'outline-primary'
              " :class="
  form.services.facebook
    ? 'col-md-10 service-button service-button--facebook--attached'
    : 'col-md-10 service-button service-button--facebook--unattached'
">
                <b-icon icon="facebook" aria-hidden="true"></b-icon>
                <span class="boldbutton">{{
                  form.services.facebook && form.services.facebook.facebook_name
                  ? form.services.facebook.facebook_name
                  : lang["attach"] + " Facebook"
                }}</span>
                <b-icon :icon="form.services.facebook ? 'check2' : 'link45deg'" aria-hidden="true"></b-icon>
              </b-button>
            </div> -->
            <!-- Google -->
            <div class="col-md-10 info-field max-width">
              <label>&nbsp;</label>
              <button @click="googleAction" :variant="form.services.google ? 'danger' : 'outline-danger'" :class="form.services.google
                ? 'col-md-10 service-button service-button--google--attached'
                : 'col-md-10 service-button service-button--google--unattached'
                ">
                <b-icon icon="google" aria-hidden="true" class="google-icon"></b-icon>
                <div class="link-google">
                  <svg class="link-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960"
                    width="24px">
                    <path
                      d="M440-280H280q-83 0-141.5-58.5T80-480q0-83 58.5-141.5T280-680h160v80H280q-50 0-85 35t-35 85q0 50 35 85t85 35h160v80ZM320-440v-80h320v80H320Zm200 160v-80h160q50 0 85-35t35-85q0-50-35-85t-85-35H520v-80h160q83 0 141.5 58.5T880-480q0 83-58.5 141.5T680-280H520Z" />
                  </svg>
                  <span class="link-google-text">{{ form.services.google && form.services.google.google_name
                    ? form.services.google.google_name
                    : lang["attach"] + " Google" }}</span>
                </div>
                <div class="link-google-hover">
                  <svg class="link-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960"
                    width="24px" fill="#FFFFFF">
                    <path
                      d="m750-291-49-49q51-10 85-48t34-89q0-58-41-99t-99-41H525v-60h155q83 0 141.5 58.5T880-477q0 62-36 112t-94 74ZM594-447l-60-60h101v60h-41ZM814-56 63-807l43-43L857-99l-43 43ZM450-280H280q-83 0-141.5-58.5T80-480q0-72 44.5-127T238-676l56 56h-14q-58 0-99 41t-41 99q0 58 41 99t99 41h170v60ZM325-450v-60h79l60 60H325Z" />
                  </svg>
                  <span class="link-google-text-hover">{{ lang["unattach"] + " Google" }}</span>
                </div>
                <!-- <b-icon :icon="form.services.google ? 'check2' : 'link45deg'" aria-hidden="true"></b-icon> -->
              </button>
            </div>
            <!-- Telegram -->
            <div v-if="telegram" class="col-md-10 info-field max-width">
              <label>&nbsp;</label>
              <button @click="telegramAction" :variant="form.services.telegram ? 'info' : 'outline-info'" :class="form.services.telegram
                ? 'col-md-10 service-button service-button--telegram--attached'
                : 'col-md-10 service-button service-button--telegram--unattached'
                ">
                <b-icon icon="telegram" aria-hidden="true" class="telegram-icon"></b-icon>
                <div class="link-telegram">
                  <svg class="link-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960"
                    width="24px">
                    <path
                      d="M440-280H280q-83 0-141.5-58.5T80-480q0-83 58.5-141.5T280-680h160v80H280q-50 0-85 35t-35 85q0 50 35 85t85 35h160v80ZM320-440v-80h320v80H320Zm200 160v-80h160q50 0 85-35t35-85q0-50-35-85t-85-35H520v-80h160q83 0 141.5 58.5T880-480q0 83-58.5 141.5T680-280H520Z" />
                  </svg>
                  <span class="link-telegram-text">{{
                    form.services.telegram && form.services.telegram.telegram_name
                      ? form.services.telegram.telegram_name
                      : lang["attach"] + " Telegram"
                  }}</span>
                </div>
                <div class="link-telegram-hover">
                  <svg class="link-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960"
                    width="24px" fill="#FFFFFF">
                    <path
                      d="m750-291-49-49q51-10 85-48t34-89q0-58-41-99t-99-41H525v-60h155q83 0 141.5 58.5T880-477q0 62-36 112t-94 74ZM594-447l-60-60h101v60h-41ZM814-56 63-807l43-43L857-99l-43 43ZM450-280H280q-83 0-141.5-58.5T80-480q0-72 44.5-127T238-676l56 56h-14q-58 0-99 41t-41 99q0 58 41 99t99 41h170v60ZM325-450v-60h79l60 60H325Z" />
                  </svg>
                  <span class="link-telegram-text-hover">{{ lang["unattach"] + " Telegram" }}</span>
                </div>
              </button>
            </div>
            <!-- Apple -->
            <div v-if="appleSign" class="col-md-10 info-field max-width">
              <label>&nbsp;</label>
              <button @click="appleAction" :variant="form.services.apple ? 'dark' : 'outline-dark'" :class="form.services.apple
                ? 'col-md-10 service-button service-button--apple--attached'
                : 'col-md-10 service-button service-button--apple--unattached'
                ">
                <svg class="apple-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1" width="20" height="22" x="0" y="0" viewBox="0 0 502.657 502.657"
                  style="enable-background:new 0 0 512 512" xml:space="preserve">
                  <g>
                    <path
                      d="M389.063 281.758c-13.827-69.587 52.223-110.399 52.223-110.399s-25.734-37.231-68.983-46.809c-43.228-9.599-64.863 2.394-86.456 11.389-21.614 9.017-32.399 9.017-32.399 9.017-31.191 0-53.992-33.025-113.419-17.99-40.941 10.332-84.04 57.594-91.827 114.002-7.787 56.429 9.017 128.432 41.416 184.236 32.399 55.847 65.403 76.835 88.828 77.439 23.426.582 46.809-16.782 75.002-21.01 28.215-4.185 45.579 10.225 73.254 18.012 27.567 7.766 37.231.561 68.983-26.446 31.838-27.007 60.657-104.467 60.657-104.467s-53.452-17.344-67.279-86.974zM327.845 79.531C358.475 48.319 348.1 0 348.1 0s-43.012 7.55-71.831 37.533c-28.797 30.005-24.03 77.396-24.03 77.396s44.975-4.206 75.606-35.398z"
                      opacity="1" data-original="#000000" />
                  </g>
                </svg>
                <div class="link-apple">
                  <svg class="link-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960"
                    width="24px">
                    <path
                      d="M440-280H280q-83 0-141.5-58.5T80-480q0-83 58.5-141.5T280-680h160v80H280q-50 0-85 35t-35 85q0 50 35 85t85 35h160v80ZM320-440v-80h320v80H320Zm200 160v-80h160q50 0 85-35t35-85q0-50-35-85t-85-35H520v-80h160q83 0 141.5 58.5T880-480q0 83-58.5 141.5T680-280H520Z" />
                  </svg>
                  <span class="link-apple-text"> {{
                    form.services.apple && form.services.apple.apple_name
                      ? form.services.apple.apple_name
                      : lang["attach"] + " Apple"
                  }}</span>
                </div>
                <div class="link-apple-hover">
                  <svg class="link-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960"
                    width="24px" fill="#FFFFFF">
                    <path
                      d="m750-291-49-49q51-10 85-48t34-89q0-58-41-99t-99-41H525v-60h155q83 0 141.5 58.5T880-477q0 62-36 112t-94 74ZM594-447l-60-60h101v60h-41ZM814-56 63-807l43-43L857-99l-43 43ZM450-280H280q-83 0-141.5-58.5T80-480q0-72 44.5-127T238-676l56 56h-14q-58 0-99 41t-41 99q0 58 41 99t99 41h170v60ZM325-450v-60h79l60 60H325Z" />
                  </svg>
                  <span class="link-apple-text-hover">{{ lang["unattach"] + " Apple" }}</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!--
        таблица в которой отображаются компании, где пользователь работает или является хозяином
      -->
      <div v-if="formCompaniesLength >= 1 || formDeletedCompaniesLength >= 1">
        <table class="table">
          <thead>
            <tr>
              <th class="none-in-mob"></th>
              <th>{{ lang['Company'] }}</th>
              <th class="description">{{ lang['description'] }}</th>
              <th v-if="form.deleted_companies.length < 1" class="none-in-mob">{{ lang['DateCreate'] }}</th>
              <th v-if="form.deleted_companies.length >= 1" class="none-in-mob">{{ lang['status'] }}</th>
              <th class="center">{{ lang['action'] }}</th>
            </tr>
          </thead>
          <tbody>
            <!-- строки действующих компаний -->
            <tr v-for="(item, index) in form.сompanies" :key="index">
              <td class="none-in-mob">
                <img v-if="item.logo.length > 1" class="logoImg" :src="logoUrl + item.company_id + '/' + item.logo"
                  alt="logo" />
                <img v-else class="logoImg"
                  src="data:image/png;base64,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"
                  alt="logo" />
              </td>

              <td class="mob-text">
                {{ item.company_name != "" ? item.company_name : "-" }}
              </td>
              <td class="description width80">
                <div class="email-and-phone-and-description-div">
                  <p class="mob-text">
                    {{
                      item.company_description != ""
                        ? item.company_description
                        : "—"
                    }}
                  </p>
                </div>
              </td>
              <td v-if="form.deleted_companies.length < 1" class="none-in-mob">
                {{ item.date_of_create != "" ? item.date_of_create : "-" }}
              </td>
              <td v-if="form.deleted_companies.length >= 1" class="none-in-mob">
                <div class="status-active"> {{ lang['active'] }}</div>
              </td>
              <td class="action-btns">
                <b-dropdown variant="outline-secondary" class="m-2">
                  <template #button-content> &#9776; </template>
                  <b-dropdown-item-button v-if="item.person_admin" @click="descEdit(index)">{{ lang['editComp']
                  }}</b-dropdown-item-button>
                  <b-dropdown-item-button v-if="!item.person_admin" @click="leaveCompany(item)">{{
                    lang['LeaveTheCompany']
                  }}</b-dropdown-item-button>
                  <b-dropdown-item-button v-else @click="transferCompany(item)">{{ lang['giveComp']
                  }}</b-dropdown-item-button>
                  <b-dropdown-divider v-if="item.person_admin"></b-dropdown-divider>
                  <b-dropdown-item-button button-class="customDropdown" v-if="item.person_admin" @click="
                    item.company_delete && item.company_delete.can_delete
                      ? deleteCompany(item)
                      : showLeftDays(item.company_delete.days_left)
                    "><span :class="item.company_delete && item.company_delete.can_delete
                      ? 'usual-btn'
                      : 'unusual-btn'
                      ">{{ lang['DelComp'] }}</span></b-dropdown-item-button>
                </b-dropdown>
              </td>
            </tr>
            <!-- строки удалённых компаний -->
            <tr class="deleted" v-for="(item, index) in form.deleted_companies" :key="index + 20">
              <td class="none-in-mob">
                <img v-if="item.logo.length > 1" class="logoImg" :src="logoUrl + item.company_id + '/' + item.logo"
                  alt="logo" />
                <img v-else class="logoImg"
                  src="data:image/png;base64,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"
                  alt="logo" />
              </td>
              <td class="mob-text">
                {{ item.company_name != "" ? item.company_name : "-" }}
              </td>
              <td class="description width80">
                <div class="email-and-phone-and-description-div">
                  <p class="mob-text">
                    {{
                      item.company_description != ""
                        ? item.company_description
                        : "—"
                    }}
                  </p>
                </div>
              </td>
              <td class="none-in-mob">
                <div class="status-deleted">{{ lang['delete'] }}</div>
              </td>
              <td class="action-btns">
                <button class="btn action-btns_btn recover-button" @click="restoreComp(index)">
                  {{ lang['recover'] }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- добавить пароль -->
    <addpassword v-if="showAddPassword" @close="(showAddPassword = false), getData()"></addpassword>
    <!-- изменить пароль -->
    <repass v-if="showRePass" @close="(showRePass = false), getData()"></repass>
    <!-- выйти из аккаунта -->
    <esc v-if="showEsc" @close="showEsc = false" @logout="logout" />
    <!-- передача компании другому пользователю (только если хозяин)-->
    <transfercompany v-if="showTransfer" @close="(showTransfer = false), getData()" :companyData="companyData" />
    <!-- выйти из компании (только если сотрудник) -->
    <leavecompany v-if="showLeave" @close="(showLeave = false), getData()" :companyData="companyData" />
    <!-- Удаление аккаунта -->
    <delac v-if="showDelAcc" :personData="form" @close="(showDelAcc = false), getData()" @goaddpass="goAddPass"></delac>
    <!-- Удаление компании -->
    <deleteComp v-if="showDelComp" @close="(showDelComp = false), getData()" :companyData="companyData" />
    <!-- для изменения почты пользователь изначально вводит новую почту(она там проверяется в модалке- существует или нет) -->
    <editemail v-if="showEditModal" @close="(showEditModal = false), getData()" :personEmail="email"
      :personPassword="form.have_password" @gopassword="goMailPass" @goaddpass="goAddPass" />
    <!-- после того как первая модалка подтвердилась и такой почты у нас нету, тогда открываем модалку где юзер должен ввести капчу и пароль от аккаунта -->
    <emailPassAndCapcha v-if="showEmailPassAndCapcha" :neweMail="newEmailData"
      @close="(showEmailPassAndCapcha = false), getData()" />
    <!-- Модалка на изменение номера телефона -->
    <editphone v-if="showEditPhone" :personPassword="form.have_password" :personPhone="personPhone"
      @close="(showEditPhone = false), getData()" @gopassword="goPhonePass" @goaddpass="goAddPass" />
    <!-- после того как первая модалка подтвердилась по изменению телефона, вызываем эту -->
    <phonePassAndCaptcha v-if="showPhonePassAndCapcha" :newphone="newPhoneData"
      @close="(showPhonePassAndCapcha = false), getData()" @goSms="goSms" />
    <!-- после пароля и введения капчи открываем окно ввода смс -->
    <phoneSMS v-if="showSms" @close="(showSms = false), getData()" :smsPhone="smsNewPhone" />
    <!-- модалка добавления почты -->
    <addemail v-if="showAddEmail" @close="(showAddEmail = false), getData()" />
    <!-- модалка изменения описания или имени компании -->
    <editCompanyNameDesc v-if="openEditCompanyNameDescModal" @close="openEditCompanyNameDescModal = false"
      @save="saveCompanyNameDesc($event)" :targetCompany="form.сompanies[targetCompanyIndex]" />
    <!-- модалка восстановления компании -->
    <restoreCompanies v-if="openRestoreCompaniesModal" @close="openRestoreCompaniesModal = false"
      @save="restoreCompanies($event)" :targetCompany="form.deleted_companies[targetCompanyIndex]" />
    <!-- модалка подтверждения удаления аккаунта -->
    <askToRemoveAcc v-if="showAskToRemoveAcc" :service="targetService" @y="removeAcc(targetService)"
      @n="showAskToRemoveAcc = false" @close="showAskToRemoveAcc = false" />
    <!-- модалка оповещения о днях ( нельзя удалять компании ) -->
    <DaysLeftModal v-if="showDeysLeftModal" :days="daysUntilDeletion" @close="showDeysLeftModal = false" />
    <!-- Нижние кнопки -->
    <template v-slot:buttons>
      <div class="buttonitem">
        <button :class="form.account_delete.can_delete
          ? 'btn btn-danger info-fields'
          : 'btn btn-danger disabled info-fields'
          " @click="
            form.account_delete.can_delete
              ? delAccount()
              : showLeftDays(form.account_delete.days_left)
            ">
          {{ lang['DeleteAccount'] }}
        </button>
      </div>
      <div class="buttonitem">
        <button class="btn btn-secondary info-fields" @click="showEsc = !showEsc">
          {{ lang['LogOut'] }}
        </button>
      </div>
    </template>
  </bigmodal>
</template>

<script>
import SelectLangs from "../LangSelectComponent.vue"; // Компонент випадаючого списку для вибору мови
import addemail from "../PersonPage/addEmail"; // Компонент для додавання пошти
import addpassword from "./addPassword";
import repass from "./rePassword"; // Компонент зміни пароля
import esc from "../Escape"; // Компонент для виходу з акаунту
import bigmodal from "../modals/bigModal"; // Компонент великого модального вікна
import transfercompany from "./transferCompany";
import leavecompany from "./leaveCompany";  // Компонент виходу з компанії
import delac from "./deleteAccount"; // Компонент видалення акаунту
import deleteComp from "./DeleteCompany"; // Компонент видалення компанії
import editemail from "./editMail"; // Компонент для редагування пошти
import editphone from "./editPhone"; // Компонент для редагування телефону
import emailPassAndCapcha from "./emailPassAndCapcha";
import phonePassAndCaptcha from "./phonePassAndCaptcha";
import phoneSMS from "./phoneSms";
import restoreCompanies from "./restoreCompanies";
import editCompanyNameDesc from "./editCompanyNameDesc";
import askToRemoveAcc from "@/components/settings/askToRemoveAcc.vue";
import DaysLeftModal from "@/components/settings/DaysLeftModal.vue";
import { store } from "@/store.js"; // Глобальне сховище даних
import { webviewCheck } from "../js/webviewCheck";  // Імпортуємо функцію для перевірки типу веб-переглядача (WebView)
import { keyevent } from '@/main.js'; // Імпорт глобального об'єкта keyevent для обміну подіями між компонентами
import { regAPi } from "@/API.js";
import getiOSVersion from "@/components/js/getiOSVersion.js"; // Імпортуємо функцію для перевірки яка версія OS встановлена в користувача

const apiList = new regAPi();

// Функція для авторизації Вінди
window.windowsAuthResult = {}
window.windowsAuthResult.success = (json) => {
  console.warn('json', json)
  let data = JSON.parse(json)
  console.warn('111s', data)
  // Гугл
  if (data.authType == 'google') {
    let token = store.token
    let postData = {
      token,
      google_token: data.googleUser.tokenId,
    };
    apiList.addGoogle(postData).then((resp) => {
      if (resp.data.status === "error") {
        if (resp.data.error == "Google Acc is already registered") {
          window.say.messageError(window.lang["googleAccIsAlreadyRegistered"]);
        } else {
          window.say.messageError(resp.data.error[0]);
        }
      } else if (resp.data.status === "done") {
        keyevent.$emit('getData')
      }
    });
    // Телеграм
  } else if (data.authType == 'telegram') {
     console.warn('2212s', data)
    let token = store.token
    let postData = {
      token,
      ...data.telegramUser,
      lang: store.lang,
    };
    apiList.addTelegram(postData).then((resp) => {
      if (resp.data.status === "error") {
        if (resp.data.error[0] === "Telegram acc is already registered") {
          window.say.messageError(this.lang["telegramAccAlreadyRegister"]);
        } else if (resp.data.error[0] === "Telegram acc is not registered") {
          window.say.messageError(this.lang["accNotRegister"]);
        } else {
          window.say.messageError(resp.data.error[0]);
        }
      } else if (resp.data.status === "done") {
        keyevent.$emit('getData')
      }
    });
    // Facebook
  } else if (data.authType == 'facebook') {
    const obj = {
      facebook_token: data.facebookUser.token,
      facebook_id: data.facebookUser.id,
      token: store.token
    };
    apiList.addFacebook(obj).then((resp) => {
      if (resp.data.status == "done") {
        keyevent.$emit('getData')
        // Якщо все ок:
      } else {
        if (resp.data.error == "FB Acc is already exist") {
          window.say.messageError(this.lang["AccountAlreadyLinked"]);
        } else if (resp.data.error == "Email is already registered") {
          window.say.messageError(this.lang["UserEmailAlreadyExists"]);
        } else if (resp.data.error == "Facebook Acc is already registered") {
          window.say.messageError(this.lang["facebookAccIsAlreadyRegistered"]);
        } else {
          window.say.messageError(resp.data.error[0]);
        }
      }
    });
  }
}

// Функція для авторизації IOS
// Google
window.iosGoogleAuthResult = {}
window.iosGoogleAuthResult.success = (token) => {
  let authObj = {
    authType: "google",
    googleUser: {
      tokenId: token
    }
  }
  window.androidAuthResult.success(JSON.stringify(authObj));
}
// Facebook
window.iosFacebookAuthResult = {}
window.iosFacebookAuthResult.success = (jsonString) => {
  let jsonObj = JSON.parse(jsonString)
  try {
    let authObj = {
      authType: "facebook",
      facebookUser: {
        userID: jsonObj.userID,
        accessToken: jsonObj.accessToken
      }
    }
    window.androidAuthResult.success(JSON.stringify(authObj));
  } catch (err) {
    // console.error(err)
  }
}

window.windowsAuthResult.error = () => {
  // alert('error')
}

// Функція для авторизації андроїдів
window.androidAuthResult = {}
window.androidAuthResult.success = (json) => {
  let data = JSON.parse(json)
  // Google
  if (data.authType == 'google') {
    let token = store.token;
    let postData = {
      token,
      google_token: data.googleUser.tokenId,
    };
    apiList.addGoogle(postData).then((resp) => {
      if (resp.data.status === "error") {
        if (resp.data.error == "Google Acc is already registered") {
          window.say.messageError(window.lang["googleAccIsAlreadyRegistered"]);
        } else {
          //Інша помилка
          window.say.messageError(resp.data.error[0]);
        }
      } else if (resp.data.status === "done") {
        keyevent.$emit('getData')
      }
    });
    // Telegram
  } else if (data.authType == 'telegram') {
    let user
    data.telegramUser = user
    let token = store.token;
    let postData = {
      token,
      ...user,
      lang: store.lang,
    };
    apiList.addTelegram(postData).then((resp) => {
      if (resp.data.status === "error") {
        if (resp.data.error[0] === "Telegram acc is already registered") {
          window.say.messageError(this.lang["telegramAccAlreadyRegister"]);
        } else if (resp.data.error[0] === "Telegram acc is not registered") {
          window.say.messageError(this.lang["accNotRegister"]);
        } else {
          window.say.messageError(resp.data.error[0]);
        }
      } else if (resp.data.status === "done") {
        keyevent.$emit('getData')
      }
    });
    // Facebook
  } else if (data.authType == 'facebook') {
    // alert(JSON.stringify(data));
    const obj = {
      facebook_token: data.facebookUser.accessToken,
      facebook_id: data.facebookUser.userID,
      token: store.token,
    };
    apiList.addFacebook(obj).then((resp) => {
      if (resp.data.status == "done") {
        keyevent.$emit('getData')
        // якщо все ок:
      } else {
        if (resp.data.error == "FB Acc is already exist") {
          window.say.messageError(this.lang["AccountAlreadyLinked"]);
        } else if (resp.data.error == "Email is already registered") {
          window.say.messageError(this.lang["UserEmailAlreadyExists"]);
        } else if (resp.data.error == "Facebook Acc is already registered") {
          window.say.messageError(this.lang["facebookAccIsAlreadyRegistered"]);
        } else {
          // Інша помилка
          window.say.messageError(resp.data.error[0]);
        }
      }
    });
  }
}
window.androidAuthResult.error = () => {
  // alert('error')
}
export default {
  components: {
    SelectLangs,
    addpassword,
    repass,
    esc,
    bigmodal,
    transfercompany,
    editCompanyNameDesc,
    restoreCompanies,
    leavecompany,
    delac,
    deleteComp,
    editemail,
    editphone,
    emailPassAndCapcha,
    phonePassAndCaptcha,
    phoneSMS,
    addemail,
    askToRemoveAcc,
    DaysLeftModal,
  },
  data() {
    return {
      logoUrl: "https://files.skyservice.pro/uploads/images/",
      newName: "",
      showEditName: false,
      descriptionEdit: [],
      telegram: false,
      facebook: false,
      form: {
        user_name: null,
        email: null,
        phone: null,
        have_password: null,
        lang: null,
        сompanies: [],
        deleted_companies: null,
        invitations: null,
        services: {
          facebook: false,
          google: false,
          telegram: false,
          apple: false,
        },
        account_delete: {
          can_delete: null,
          days_left: null
        }
      },
      showEsc: false,
      showAddPassword: false,
      showRePass: false,
      personLang: "",
      email: "",
      personPhone: "",
      companyData: null,
      showTransfer: false,
      showLeave: false,
      showDelAcc: false,
      showDelComp: false,
      showEditModal: false,
      showEmailPassAndCapcha: false,
      newEmailData: null,
      showEditPhone: false,
      newPhoneData: null,
      showPhonePassAndCapcha: false,
      showСheckSessions: false,
      showSms: false,
      smsNewPhone: null,
      showAddEmail: false,
      openEditCompanyNameDescModal: false,
      openRestoreCompaniesModal: false,
      showAskToRemoveAcc: false,
      targetService: "",
      gglClient: null,
      showDeysLeftModal: false,
      daysUntilDeletion: null,
    };
  },

  created() {
    // выключаем соц сети (временно)
    //              google 	telegram 	facebook	
    // Браузер	      1	       1	       0	
    // Android   	    1	       0	       0	
    // Windows   	    1	       1	       0	
    // ios           	1	       0	       0	

    // Слухачі для авторизації через apple для ios додатків
    window.ioshttpsender = {
      AppleIDSignInOnSuccess: (response) => {
        try {
          const responseData = JSON.parse(response)
          const appleToken = responseData.identityToken;
          this.addApple(appleToken)
        } catch (err) {
          window.say.messageError(this.lang['Error']);
        }
      },
      AppleIDSignInOnFailure: (error) => {
        console.error(error);
        window.say.messageError(this.lang['notGetDataFromApple']);
      }
    }

    let userAgent = window.navigator.userAgent.toLowerCase(),
      safari = /safari/.test(userAgent),
      ios = /iphone|ipod|ipad/.test(userAgent);

    if (webviewCheck() == "android_webview") {
      this.telegram = true;
    } else if (webviewCheck() == "cef_webview") {
      this.telegram = true;
    } else if (webviewCheck() == "ios_webview" && !safari) {
      this.telegram = true;
    } else if (ios && safari) {
      this.telegram = true;
    } else {
      this.telegram = true;
    }
    this.getData();
  },
  mounted() {
    keyevent.$off('getData');
    keyevent.$on('getData', () => {
      this.getData();
    });
    // Для авторизації FB
    // eslint-disable-next-line
    FB.init({
      appId: "348596312928771",
      xfbml: true,
      version: "v13.0",
    });
    // Для авторизації по гуглу
    // eslint-disable-next-line
    this.gglClient = google.accounts.oauth2.initTokenClient({
      client_id:
        "910811730153-q8m9pb2rkt372dlf3u3te7kggbhj3aiu.apps.googleusercontent.com",
      scope:
        "email profile https://www.googleapis.com/auth/userinfo.email openid https://www.googleapis.com/auth/userinfo.profile",
      callback: (response) => {
        this.addGoogle(response.access_token);
      },
    });
    if (webviewCheck() == 'ios_webview') {
      window.webkit.messageHandlers.getAppVersion.postMessage('');
      window.ioshttpsender = {
        // Отримання і встановлення версії додатку IOS
        setAppVersion(appData) {
          let data = JSON.parse(appData);
          const { osVersion, deviceModel, appVersion } = data;
          store.appInfoData = {
            os: osVersion,
            appVersion: appVersion,
            device: deviceModel
          }
        }
      }
    }
    console.error('getiOSVersion() -->', getiOSVersion())
    console.error('webviewCheck() == ios_webview -->', webviewCheck() == 'ios_webview')
    console.error('store.appInfoData.appVersion', store?.appInfoData?.appVersion)
  },
  methods: {
    iosAuthGoogle() {
      try {
        // eslint-disable-next-line
        window.webkit.messageHandlers.GoogleAuth.postMessage("");
      } catch (err) {
        // console.log('err')
      }
    },
    iosAuthFacebook() {
      try {
        // eslint-disable-next-line
        window.webkit.messageHandlers.FacebookAuth.postMessage("");
      } catch (err) {
        // console.log('err')
      }
    },
    // Метод для авторизації Вінди
    windowsAuth(type) {
      let request
      if (type === "telegram") {
        // request = {"method":"auth","data":"{'command':'auth','authType':'telegram', bind: 'cabinet'}"}
        // request = `{"method":"auth","data":"{'command':'auth','authType':'telegram', bind: 'cabinet', token: ${store?.token}}"}`
        const dataInner = `{'command':'auth','authType':'telegram', bind: 'cabinet', token: '${store?.token}'}`;
        request = {
          method: "auth",
          data: dataInner
        };
      } else {
        request = {
        method: "auth",
        data: JSON.stringify({
          command: "auth",
          authType: type
        })
      }
      }
      console.warn('parse', request)
      console.warn('toJava', JSON.stringify(request))
      window.cefQuery({
        request: JSON.stringify(request),
        persistent: true,
        onSuccess: function (responseJson) {
          console.log(responseJson)
        },
        onFailure: function (error_code, error_message) {
          console.log(error_code, error_message)
        }
      });
    },
    // Метод для виходу Вінда
    windowAuthEsc(t) {
      let data = {
        command: "logout",
        authType: t,
      }
      let request = {
        method: "logout",
        data: JSON.stringify(data)
      };
      window.cefQuery({
        request: JSON.stringify(request),
        persistent: true,
        onSuccess: function (responseJson) {
          console.log(responseJson)
        },
        onFailure: function (error_code, error_message) {
          console.log(error_code, error_message)
        }
      });
    },
    // Метод для виходу андроїдів
    androidAuthEsc(t) {
      let authData = {
        "command": 'logout',
        "authType": t,
      }
      try {
        // eslint-disable-next-line
        Android.auth(JSON.stringify(authData))
      } catch (err) {
        // console.log('err')
      }
    },
    // Метод для авторизації андроїдів
    androidAuth(t) {
      let authData = {
        "command": 'auth',
        "authType": t,
      }
      try {
        // eslint-disable-next-line
        Android.auth(JSON.stringify(authData))
      } catch (err) {
        // console.log('err')
      }
    },
    // Показує, скільки днів залишилося до можливості видалення компанії
    showLeftDays(days) {
      this.daysUntilDeletion = days;
      this.showDeysLeftModal = true;
    },
    goBack() {
      this.showEditName = false;
      this.newName = this.form.user_name;
    },
    // Змінюємо name
    editName() {
      if (this.stateName) {
        try {
          apiList
            .editName({ token: store.token, user_name: this.newName })
            .then((resp) => {
              if (resp.data.status == "done") {
                this.getData();
                this.showEditName = false;
                window.say.message(this.lang['Saved']);
              } else {
                window.say.messageError(this.lang['Error']);
              }
            });
        } catch (err) {
          window.say.messageError(this.lang['Error']);
        }
      } else {
        window.say.messageError(this.lang['writeCorrectlyName']);
      }
    },
    // language change
    changeLang(l) {
      try {
        apiList.language({ token: store.token, lang: l }).then((resp) => {
          if (resp.data.status == "done") {
            this.getData();
            localStorage.setItem("lang_user", l);
            store.lang = l;
            window.lang = store.langs[store.lang]();
            // Цей таймаут необхідний, щоб користувач побачив напис "ЗБЕРЕЖЕНО" обраною ним мовою
            setTimeout(() => {
              window.say.message(this.lang['Saved']);
            }, 500);
          } else {
            window.say.messageError(this.lang['Error']);
          }
        });
      } catch (err) {
        window.say.messageError(this.lang['Error']);
      }
    },
    // Модалка відновлення компанії
    restoreComp(index) {
      this.targetCompanyIndex = index;
      this.openRestoreCompaniesModal = true;
    },
    // Відновлення компанії
    restoreCompanies(data) {
      const obj = {
        token: store.token,
        ...data,
      };
      apiList.recoverCompany(obj).then((resp) => {
        if (resp.data.status == "done") {
          window.say.message(this.lang['restored']);
          this.getData();
          this.openRestoreCompaniesModal = false;
        } else if (resp.data.error == "Captcha is incorrect") {
          window.say.messageError(this.lang['IncorrectCaptcha']);
        } else if (resp.data.error == "pass is incorrect") {
          window.say.messageError(this.lang['WrongPassword']);
        } else {
          window.say.messageError(this.lang["Error"]);
        }
      });
    },
    facebookAction() {
      console.log(event)
      if (this.form.services.facebook) {
        // если есть привязка
        this.targetService = "facebook";
        this.showAskToRemoveAcc = true; // Питаємо дійсно хочете відв'язати акаунт
        console.log('if', this.form.services.facebook)
      } else {
        if (webviewCheck() == "android_webview") {
          this.androidAuth("facebook")
        } else if (webviewCheck() == "cef_webview") {
          this.windowsAuth("facebook")
        } else if (webviewCheck() == "ios_webview") {
          this.iosAuthFacebook("facebook");
        } else {
          console.log('else')
          // eslint-disable-next-line
          FB.login(
            (response) => {
              console.log('else', this.form.services.facebook)
              if (response.status == "connected") {
                this.addFacebook(response);
              }
            },
            { scope: "public_profile,email" }
          );
        }
      }
    },
    googleAction() {
      if (this.form.services.google) {
        // если есть привязка
        this.targetService = "google";
        this.showAskToRemoveAcc = true; // Питаємо дійсно хочете відв'язати акаунт
      } else {
        if (webviewCheck() == "android_webview") {
          this.androidAuth("google")
        } else if (webviewCheck() == "cef_webview") {
          this.windowsAuth("google")
        } else if (webviewCheck() == "ios_webview") {
          this.iosAuthGoogle("google")
        } else {
          this.gglClient.requestAccessToken();
        }
      }
    },
    telegramAction() {
      if (this.form.services.telegram) {
        // если есть привязка
        this.targetService = "telegram";
        this.showAskToRemoveAcc = true; // Питаємо дійсно хочете відв'язати акаунт
      } else {
        if (webviewCheck() == "android_webview") {
          this.androidAuth("telegram")
        } else if (webviewCheck() == "cef_webview") {
          this.windowsAuth("telegram")
        } else {
          window.Telegram.Login.auth(
            { bot_id: "5308819120", request_access: "read" },
            (data) => {
              if (!data) {
                // console.error("Error");
              } else {
                this.addTelegram(data);
              }
            }
          );
        }
      }
    },
    // Дії з кнопкою підв'язки Apple
    appleAction() {
      try {
        if (this.form.services.apple) {
          // Якщо є прив'язка
          this.targetService = "apple";
          this.showAskToRemoveAcc = true; // Питаємо дійсно хочете відв'язати акаунт
        } else {
          if (webviewCheck() == 'ios_webview') {
            this.signInWithAppleForIOSApp()
          } else if (webviewCheck() == 'browser') {
            this.signInWithAppleForBrowser()
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    // Авторизація через apple для додатку на ios
    signInWithAppleForIOSApp() {
      window.webkit.messageHandlers.handleAppleSignIn.postMessage('');
    },
    // Авторизація через apple для браузера
    signInWithAppleForBrowser() {
      // Ініціалізація Apple Sign In
      window.AppleID.auth.init({
        clientId: "pro.skeservice.app",
        scope: 'name email', // Вказати необхідні області
        redirectURI: "https://cabinet.skyservice.online/",
        usePopup: true,
      });
      // Виклик методу для відображення вікна авторизації
      window.AppleID.auth.signIn()
        .then(response => {
          const appleToken = response.authorization.id_token;
          this.addApple(appleToken);
        })
        .catch(error => {
          console.error('Ошибка аутентификации:', error);
        });
    },
    // Прив'язка apple акаунта
    addApple(appleToken) {
      try {
        let token = store.token;
        const obj = {
          token,
          apple_token: appleToken,
          lang: store.lang,
        };
        apiList.addApple(obj).then((resp) => {
          console.warn("authApple_resp", resp);
          if (resp.data.status == "error") {
            if (resp.data.error === "AppleID is already registered") {
              window.say.messageError(window.lang["appleAccIsAlreadyRegistered"]);
            } else {
              // Другая ошибка
              window.say.messageError(resp.data.error[0]);
            }
          } else if (resp.data.status === "done") {
            this.getData();
          }
        });
      } catch (err) {
        // console.error(err);
        window.say.messageError(this.lang['Error']);
      }
    },
    // Прив'язка гугл акаунту
    addGoogle(accessToken) {
      let token = store.token;
      let postData = {
        token,
        google_token: accessToken,
      };
      apiList.addGoogle(postData).then((resp) => {
        if (resp.data.status === "error") {
          if (resp.data.error == "Google Acc is already registered") {
            window.say.messageError(window.lang["googleAccIsAlreadyRegistered"]);
          } else {
            //Інша помилка
            window.say.messageError(resp.data.error[0]);
          }
        } else if (resp.data.status === "done") {
          this.getData();
        }
      });
    },
    // прив'язка фейсбук акаунту
    addFacebook(response) {
      try {
        if (response.status == "connected") {
          try {
            // нам ФБ віддає токен і айді користувача, який перевіряється на бекенді
            const obj = {
              facebook_token: response.authResponse.accessToken,
              facebook_id: response.authResponse.userID,
              token: store.token,
            };
            apiList.addFacebook(obj).then((resp) => {
              if (resp.data.status == "done") {
                this.getData();
                // если все ок:
              } else {
                if (resp.data.error == "FB Acc is already exist") {
                  window.say.messageError(this.lang["AccountAlreadyLinked"]);
                } else if (resp.data.error == "Email is already registered") {
                  window.say.messageError(this.lang["UserEmailAlreadyExists"]);
                } else if (resp.data.error == "Facebook Acc is already registered") {
                  window.say.messageError(this.lang["facebookAccIsAlreadyRegistered"]);
                } else {
                  //Інша помилка
                  window.say.messageError(resp.data.error[0]);
                }
              }
            });
          } catch (err) {
            window.say.messageError(this.lang["Error"]);
          }
        }
      } catch (err) {
        // console.log(err)
      }
    },
    // Прив'язка телеграм акаунту
    addTelegram(userData) {
      let token = store.token;
      let postData = {
        token,
        ...userData,
        lang: store.lang,
      };

      apiList.addTelegram(postData).then((resp) => {
        if (resp.data.status === "error") {
          if (resp.data.error[0] === "Telegram acc is already registered") {
            window.say.messageError(this.lang["telegramAccAlreadyRegister"]);
          } else if (resp.data.error[0] === "Telegram acc is not registered") {
            window.say.messageError(this.lang["accNotRegister"]);
          } else {
            window.say.messageError(resp.data.error[0]);
          }
        } else if (resp.data.status === "done") {
          this.getData();
        }
      });
    },
    removeAcc(service) {
      let token = store.token;

      switch (service) {
        case "facebook":
          if (webviewCheck() == "android_webview") {
            this.androidAuthEsc("facebook")
          } else if (webviewCheck() == "cef_webview") {
            this.windowAuthEsc("facebook")
          }
          this.removeFacebookAcc(token);
          break;
        case "google":
          if (webviewCheck() == "android_webview") {
            this.androidAuthEsc("google")
          }
          // } else if (webviewCheck() == "cef_webview"){
          //   this.windowAuthEsc("google")
          // }
          this.removeGoogleAcc(token);
          break;
        case "telegram":
          if (webviewCheck() == "android_webview") {
            this.androidAuthEsc("telegram")
            // } else if (webviewCheck() == "cef_webview"){
            //   this.windowAuthEsc("telegram")
          }
          this.removeTelegramAcc(token);
          break;
        case "apple":
          this.removeAppleAcc(token);
          break;
      }
    },
    removeFacebookAcc(token) {
      apiList.removeFacebook(token).then((resp) => {
        if (resp.data.status === "error") {
          window.say.messageError(resp.data.error[0]);
        } else if (resp.data.status === "done") {
          this.getData();
        }
      });
    },
    removeGoogleAcc(token) {
      apiList.removeGoogle(token).then((resp) => {
        if (resp.data.status === "error") {
          window.say.messageError(resp.data.error[0]);
        } else if (resp.data.status === "done") {
          this.getData();
        }
      });
    },
    removeTelegramAcc(token) {
      apiList.removeTelegram(token).then((resp) => {
        if (resp.data.status === "error") {
          window.say.messageError(resp.data.error[0]);
        } else if (resp.data.status === "done") {
          this.getData();
        }
      });
    },
    // від'язуємо Apple аккаунт
    removeAppleAcc(token) {
      apiList.removeApple(token).then((resp) => {
        if (resp.data.status === "error") {
          window.say.messageError(resp.data.error[0]);
        } else if (resp.data.status === "done") {
          this.getData();
        }
      });
    },
    // Збереження опису та назви компанії
    saveCompanyNameDesc(data) {
      this.form.сompanies[this.targetCompanyIndex].company_name = data.name;
      this.form.сompanies[this.targetCompanyIndex].company_description =
        data.desc;
      let logo = data.logo;

      apiList
        .saveSettings({
          ...this.form.сompanies[this.targetCompanyIndex],
          logo,
          token: store.token,
        })
        .then((resp) => {
          if (resp.data.status == "done") {
            window.say.message(this.lang['Saved']);
            this.getData();
          } else {
            // console.log("err");
          }
        });
    },
    // Редагування опису та назви компанії
    descEdit(index) {
      this.targetCompanyIndex = index;
      this.openEditCompanyNameDescModal = true;
    },
    // Кнопка видалення компанії
    deleteCompany(i) {
      this.companyData = i;
      this.showDelComp = !this.showDelComp;
    },
    // если юзер не создать пароль перед тем как захотел поменять почту или мыло
    goAddPass() {
      this.showAddPassword = true;
    },
    // вызываем модалку для ввода пароля и капчи при смене мыла
    goMailPass(item) {
      this.newEmailData = item;
      this.showEmailPassAndCapcha = true;
    },
    goPhonePass(item) {
      this.newPhoneData = item;
      this.showPhonePassAndCapcha = true;
    },
    goSms(item) {
      this.smsNewPhone = item;
      this.showSms = true;
    },
    // Видалення акаунту користувача
    delAccount() {
      this.showDelAcc = !this.showDelAcc;
    },
    // Виклик модалки для передачі компанії
    transferCompany(i) {
      this.companyData = i;
      this.showTransfer = !this.showTransfer;
    },
    // Виклик модалки щоб покинути компанію
    leaveCompany(i) {
      this.companyData = i;
      this.showLeave = !this.showLeave;
    },
    // Закривавємо модалку і викликаємо у батька Person метод getData();
    closeWindow() {
      this.$emit("updateData");
      this.$emit("close");
    },
    getData() {
      try {
        apiList.getPersonData(store.token).then((resp) => {
          if (resp.data.status == "error") {
            document.location.href = "https://auth.skyservice.online/";
          }
          if (resp.data.data.lang != "") {
            this.personLang = resp.data.data.lang;
          } else {
            this.personLang = store.lang;
          }
          this.form = resp.data.data;
          if (!this.form.user_name) {
            this.form.user_name = this.lang['withoutName']
          }
          this.newName = this.form.user_name;
          if (resp.data.data.сompanies) {
            this.form.сompanies = resp.data.data.сompanies.map((item) => {
              return {
                ...item,
                descriptionEdit: false,
              };
            });
          }
          // Відслідковуємо зміни мови
          if (this.form.lang != "") {
            window.lang = store.langs[this.form.lang]();
          }
          // записываем текущее мыло
          this.email = this.form.email;
          this.personPhone = this.form.phone;
          this.phoneLength;
        });
      } catch (err) {
        // console.log(err);
      }
    },
    logout() {
      this.showEsc = false;
      this.$emit("close");
    },
  },
  computed: {
    // отримуємо корректну версію IOS, MacOS
    appleSign() {
      return (webviewCheck() == 'ios_webview' && getiOSVersion() && store.appInfoData.appVersion >= 6) || webviewCheck() == 'browser';
    },
    formCompaniesLength() {
      try {
        return this.form.сompanies.length;
      } catch (err) {
        return 0;
      }
    },
    formDeletedCompaniesLength() {
      try {
        return this.form.deleted_companies.length;
      } catch (err) {
        return 0;
      }
    },
    stateName() {
      const reg = /^(?!\s)[\p{L}\p{Mn}\p{Nd}\p{Pc}]+(\s[\p{L}\p{Mn}\p{Nd}\p{Pc}]+)*$/u
      if (reg.test(this.newName) && this.newName.length > 2 && this.newName.length <= 20) return true;
      else return false;
    },
    // Мова додатку
    lang() {
      return store.langs[store.lang]();
    },
  },
};
</script>

<style scoped>
.width80 {
  max-width: 80px;
}

.center {
  text-align: center;
}

/* .deleted {
  background-color: rgb(248 232 233);
} */

.max-width {
  max-width: 100%;
}

.info-fields {
  width: 100%;
}

.h5-service-name {
  height: 32px;
  margin-bottom: 20px;
}

.add-email {
  width: 100%;
  color: #ff3548;
  border-color: #ff3548;
}

.add-email:hover {
  width: 100%;
  color: white;
  background-color: #ff3548;
  border-color: #ff3548;
}

.add-email:active {
  width: 100%;
  color: white;
  background-color: #ff3548;
  border-color: #ff3548;
}

.email-else {
  margin-bottom: 16px;
}


.blue-color {
  color: #007bff;
}

.btn-name {
  position: relative;
  bottom: 5px;
}

.person-settings_name {
  display: flex;
  height: 32px;
  margin-bottom: 20px;
  cursor: pointer;
}

.col-md-10 {
  padding: 0;
}

.person-settings {
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 15px;
}

.mob-text {
  max-width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.unusual-btn {
  color: grey;
}


.service-button--facebook--unattached:hover {
  color: white;
}

.google-icon {
  width: 18px;
  height: 18px;
}

.service-button--google--unattached,
.service-button--google--attached {
  padding: 6px 12px;
  background-color: white;
  color: #434343;
  fill: #434343;
  border: 1px solid gray;
  border-radius: 5px;
}

.service-button--google--unattached:hover {
  color: white;
  fill: white;
  background-color: #00c279;
  border: 1px solid #00c279;
}

.service-button--google--attached:hover {
  padding: 6px 12px;
  background-color: #FF4B4B;
  color: white;
  fill: white;
  border: 1px solid #FF4B4B;
  border-radius: 5px;
}

.service-button--google--attached:hover .link-google-hover {
  display: flex;
}

.service-button--google--attached:hover .link-google {
  display: none;
}

.telegram-icon {
  width: 20px;
  height: 20px;
}

.service-button--telegram--unattached,
.service-button--telegram--attached {
  padding: 6px 12px;
  background-color: white;
  color: #434343;
  fill: #434343;
  border: 1px solid gray;
  border-radius: 5px;
}

.service-button--telegram--unattached:hover {
  color: white;
  fill: white;
  background-color: #00c279;
  border: 1px solid #00c279;
}

.service-button--telegram--attached:hover {
  padding: 6px 12px;
  background-color: #FF4B4B;
  color: white;
  fill: white;
  border: 1px solid #FF4B4B;
  border-radius: 5px;
}

.service-button--telegram--attached:hover .link-telegram-hover {
  display: flex;
}

.service-button--telegram--attached:hover .link-telegram {
  display: none;
}

.apple-icon {
  fill: #000;
  transition: 1ms;
}

.service-button--apple--attached:hover>.apple-icon {
  fill: #fff;
}

.service-button--apple--unattached,
.service-button--apple--attached {
  padding: 6px 12px;
  background-color: white;
  color: #434343;
  fill: #434343;
  border: 1px solid gray;
  border-radius: 5px;
}

.service-button--apple--unattached:hover {
  color: white;
  fill: white;
  background-color: #00c279;
  border: 1px solid #00c279;
}

.service-button--apple--unattached:hover>.apple-icon {
  fill: #fff;
}

.service-button--apple--attached:hover {
  padding: 6px 12px;
  background-color: #FF4B4B;
  color: white;
  fill: white;
  border: 1px solid #FF4B4B;
  border-radius: 5px;
}

.service-button--apple--attached:hover .link-apple-hover {
  display: flex;
}

.service-button--apple--attached:hover .link-apple {
  display: none;
}

.link-google-text::first-letter,
.link-google-text-hover::first-letter,
.link-telegram-text::first-letter,
.link-telegram-text-hover::first-letter,
.link-apple-text::first-letter,
.link-apple-text-hover::first-letter {
  text-transform: uppercase;
}

.link-google,
.link-telegram,
.link-apple {
  display: flex;
  flex-flow: row;
  gap: 7px;
  margin: 0 auto;
}

.link-google-text,
.link-google-text-hover,
.link-telegram-text,
.link-telegram-text-hover,
.link-apple-text,
.link-apple-text-hover {
  font-size: 16px;
  font-weight: 600;
  align-items: center;
  margin-top: -1px;
}

.link-google-hover,
.link-telegram-hover,
.link-apple-hover {
  display: none;
  flex-flow: row;
  gap: 10px;
  margin: 0 auto;
}

@media (min-width: 320px) and (max-width: 399px) {

  .link-google-text,
  .link-google-text-hover,
  .link-telegram-text,
  .link-telegram-text-hover,
  .link-apple-text,
  .link-apple-text-hover {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px;
  }
}

@media (min-width: 400px) and (max-width: 766px) {

  .link-google-text,
  .link-google-text-hover,
  .link-telegram-text,
  .link-telegram-text-hover,
  .link-apple-text,
  .link-apple-text-hover {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 190px;
  }
}

@media (max-width: 766px) {
  .h5-service-name {
    height: auto;
    margin-bottom: 0;
  }
}

@media (min-width: 767px) and (max-width: 960px) {

  .link-google-text,
  .link-google-text-hover,
  .link-telegram-text,
  .link-telegram-text-hover,
  .link-apple-text,
  .link-apple-text-hover {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 155px;
  }
}

@media (min-width: 961px) {

  .link-google-text,
  .link-google-text-hover,
  .link-telegram-text,
  .link-telegram-text-hover,
  .link-apple-text,
  .link-apple-text-hover {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 190px;
  }
}


@media screen and (max-width: 767px) {
  .person-settings {
    flex-direction: column;
  }

  .person-settings_services {
    width: 100%;
  }

  .person-settings_info {
    width: 100%;
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 450px) {
  .description {
    display: none;
  }
}

.logoImg {
  width: 50px;
  border-radius: 12px;
}

.services-buttons {
  padding: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.services-buttons button {
  /* display: flex;
          flex-direction: column; */
  text-align: start !important;
  font-size: 16px;
}

.service-button {
  /* margin-left: auto; */
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.person-settings {
  display: flex;
}

@media screen and (min-width: 767px) {

  .person-settings_info,
  .person-settings_services {
    width: 50%;
  }
}

.links_block {
  padding: 15px 45px 15px 0px;
  /* display: flex;
  justify-content: space-between; */
}

p {
  margin: 0;
}

.table {
  width: 100%;
  text-align: center;
  vertical-align: middle;
}

.table thead th {
  border-bottom: 1px solid #dee2e6;
}

.table th,
.table td {
  vertical-align: inherit;
  border-top: none;
}

.name-div {
  height: 32px;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.name-input {
  border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
}

.form-control.is-valid,
.form-control.is-valid:focus {
  border-color: #00c279;
}

.form-control.is-valid {
  border-color: #00c279;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2300C279' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
}

.form-control.is-invalid,
.form-control.is-invalid:focus {
  border-color: #ff3548;
}

.form-control.is-invalid {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ff3548' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
}

.name-button {
  height: calc(1.5em + 0.75rem + 2px);
}


.name-button {
  background-color: #00c279;
  border: none;
  color: white;
}


.name-button:not(:disabled):not(.disabled):active {
  background-color: #00B26F;
  color: white;
}


.name-button:hover {
  background-color: #00B26F;
  color: white;
}

.email-and-phone-and-description-div {
  display: flex;
  justify-content: center;
}

.email-and-phone-and-description-div>input {
  border-radius: 0.25rem 0 0 0.25rem;
}

.email-and-phone-and-description-div>button {
  height: calc(1.5em + 0.75rem + 2px);
  border-radius: 0 0.25rem 0.25rem 0;
}

.add-company {
  color: #007bff;
  cursor: pointer;
  margin-bottom: 1rem;
  font-weight: 500;
}

.add-company:hover {
  text-decoration: underline;
}


.h5-user-name {
  max-width: 100%;
}

.action-btns_btn {
  width: 10rem;
}

.status-active,
.status-deleted {
  display: inline-block;
  padding: 6px 8px;
  font-weight: 500;
  border-radius: 10px;
}

.status-active {
  background-color: #E8FDEF;
  color: #41BB53;
}

.status-deleted {
  background-color: #FEE3E5;
  color: #DC3545;
}

.recover-button {
  background-color: #007bff;
  border: none;
  color: white;
}

.recover-button:hover {
  background-color: #006CE1 !important;
  color: white !important;
}

.recover-button:active {
  background-color: #006CE1 !important;
}

/deep/.dropdown-item:hover {
  background-color: #007AFF !important;
  color: white !important;
}

/deep/.customDropdown:hover .unusual-btn {
  background-color: #007AFF !important;
  color: #94C7FF;
}

/* .action-btns {
    display: flex;
    justify-content: center;
  } */
/* .action-btns_btn {
          display: flex;
          justify-content: center;
          align-items: center;
      } */
/* .action-btns_btn span {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .action-btns_btn span::before {
    font-size: 20px;
  }
  .action-btns_btn:not(:last-child) {
    margin-right: 1rem;
  } */
@media screen and (max-width: 768px) {
  .none-in-mob {
    display: none;
  }

  .mob-text {
    white-space: nowrap;
    overflow: hidden;
    max-width: 130px;
    text-overflow: ellipsis;
  }
}

.input-edit-button {
  background-color: #e9ecef;
  border-color: #ced4d9;
  border-left: none;
  color: #3a484e;
}

.boldbutton {
  font-weight: 500;
}

.rollBack {
  margin-left: 7px;
  margin-right: 7px;
  padding: 0px 7px;
  background-color: #f75656;
  border-color: #f75656;
  height: calc(1.5em + 0.75rem + 2px);
}

.rollBack:hover {
  background-color: #d64545;
  border-color: #d64545;
}
</style>